import React, { useState, useEffect } from 'react';
import api from '../../api';
import LoadingSpinner from '../../components/LoadingSpinner';
import FixtureForm from './FixtureForm';
import FixtureTable from './FixtureTable';

const todayFormatted = () => new Date().toLocaleDateString('en-GB');

const emptyForm = () => ({
  torneo: '',
  jornada: '',
  vsTeam: '',
  isHome: true,
  date: todayFormatted(),
  matchHours: '',
  venue: '',
  result: '',
  status: 'Programado',
  phase: '',
});

const TABS = [
  { key: 'liga',          label: 'Liga Profesional Argentina', torneos: ['Liga Profesional Argentina'] },
  { key: 'copa_argentina', label: 'Copa Argentina',            torneos: ['Copa Argentina'] },
  { key: 'internacionales', label: 'Copas Internacionales',   torneos: ['Copa Sudamericana', 'Copa Libertadores'] },
];

const Fixture = () => {
  const [fixtures, setFixtures] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState(emptyForm());
  const [activeTab, setActiveTab] = useState('liga');

  const fetchFixtures = async () => {
    setLoading(true);
    try {
      const response = await api.get('/fixtures');
      setFixtures(response.data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFixtures();
  }, []);

  const handleDelete = async (id) => {
    try {
      await api.delete(`/fixture/${id}`);
      fetchFixtures();
    } catch (error) {
      console.error('Error deleting fixture:', error);
    }
  };

  const handleEdit = async (updatedFixture) => {
    try {
      await api.put(`/fixture/${updatedFixture.id}`, updatedFixture);
      fetchFixtures();
    } catch (error) {
      console.error('Error editing fixture:', error);
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const payload = { ...formData, jornada: Number(formData.jornada), phase: formData.phase || null };
    await api.post('/fixture', payload);
    fetchFixtures();
    setFormData(emptyForm());
  };

  const currentTab = TABS.find((t) => t.key === activeTab);
  const filteredFixtures = fixtures.filter((f) => currentTab.torneos.includes(f.torneo));

  return (
    <div className="container">
      <h2 className="mt-3 mb-3">Fixture</h2>
      <FixtureForm formData={formData} onInputChange={handleInputChange} onSubmit={handleSubmit} />
      <div style={{ height: '40px' }} />

      {/* Tabs de torneo */}
      <div style={{ display: 'flex', gap: '8px', marginBottom: '16px', borderBottom: '2px solid #dee2e6', paddingBottom: '0' }}>
        {TABS.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            style={{
              padding: '8px 18px',
              border: 'none',
              borderRadius: '6px 6px 0 0',
              cursor: 'pointer',
              fontWeight: activeTab === tab.key ? '700' : '400',
              backgroundColor: activeTab === tab.key ? '#C73B33' : '#f0f0f0',
              color: activeTab === tab.key ? '#fff' : '#333',
              borderBottom: activeTab === tab.key ? '2px solid #C73B33' : '2px solid transparent',
              marginBottom: '-2px',
            }}
          >
            {tab.label}
            <span style={{
              marginLeft: '8px',
              backgroundColor: activeTab === tab.key ? 'rgba(255,255,255,0.25)' : '#ddd',
              color: activeTab === tab.key ? '#fff' : '#666',
              borderRadius: '10px',
              padding: '1px 7px',
              fontSize: '12px',
            }}>
              {fixtures.filter((f) => tab.torneos.includes(f.torneo)).length}
            </span>
          </button>
        ))}
      </div>

      {loading ? (
        <LoadingSpinner />
      ) : (
        <FixtureTable fixtures={filteredFixtures} onDelete={handleDelete} onEdit={handleEdit} />
      )}
    </div>
  );
};

export default Fixture;
